export function getView(receivable_id) {
  return receivable_id ? 'ReceivableMessage' : 'Toggle'
}
